import { auth } from "../firebase";

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:5000/api";

export const uploadImageToBackend = async (
  file: File,
  productId: string
): Promise<string> => {
  try {
    // Get the current user's ID token
    const user = auth.currentUser;
    if (!user) {
      throw new Error("User must be authenticated to upload images");
    }

    const token = await user.getIdToken();

    // Create FormData
    const formData = new FormData();
    formData.append("image", file);
    formData.append("productId", productId);

    // Upload to backend
    const response = await fetch(`${API_BASE_URL}/upload/image`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Upload failed");
    }

    const result = await response.json();
    return result.url;
  } catch (error) {
    console.error("Error uploading image to backend:", error);
    const errorMessage =
      error instanceof Error ? error.message : "Unknown error";
    throw new Error(`Failed to upload image: ${errorMessage}`);
  }
};

export const uploadMultipleImagesToBackend = async (
  files: File[],
  productId: string
): Promise<string[]> => {
  try {
    // Get the current user's ID token
    const user = auth.currentUser;
    if (!user) {
      throw new Error("User must be authenticated to upload images");
    }

    const token = await user.getIdToken();

    // Create FormData
    const formData = new FormData();
    files.forEach((file) => {
      formData.append("images", file);
    });
    formData.append("productId", productId);

    const response = await fetch(`${API_BASE_URL}/upload/images`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Upload failed");
    }

    const result = await response.json();
    return result.images.map((img: any) => img.url);
  } catch (error) {
    console.error("Error uploading images to backend:", error);
    const errorMessage =
      error instanceof Error ? error.message : "Unknown error";
    throw new Error(`Failed to upload images: ${errorMessage}`);
  }
};
